import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormStateService {
  private readonly _paymentFormDirty = signal(false);
  readonly paymentFormDirty = this._paymentFormDirty.asReadonly();

  private readonly _contactInfoFormDirty = signal(false);
  readonly contactInfoFormDirty = this._contactInfoFormDirty.asReadonly();

  private readonly _contactInfoConfirmPending = signal(false);
  readonly contactInfoConfirmPending = this._contactInfoConfirmPending.asReadonly();

  private readonly _helocFormDirty = signal(false);
  readonly helocFormDirty = this._helocFormDirty.asReadonly();

  private readonly _contactInfoEditingIndex = signal(-1);
  readonly contactInfoEditingIndex = this._contactInfoEditingIndex.asReadonly();

  setPaymentFormDirty(isDirty: boolean): void {
    this._paymentFormDirty.set(isDirty);
  }

  hasPaymentChanges(): boolean {
    return this._paymentFormDirty();
  }

  setContactInfoFormDirty(isDirty: boolean): void {
    this._contactInfoFormDirty.set(isDirty);
  }

  setContactInfoEditingIndex(index: number): void {
    this._contactInfoEditingIndex.set(index);
  }

  isEditingContactInfo(): boolean {
    return this._contactInfoEditingIndex() >= 0;
  }

  setContactInfoConfirmPending(isPending: boolean): void {
    this._contactInfoConfirmPending.set(isPending);
  }

  hasContactInfoChanges(): boolean {
    return this._contactInfoFormDirty() || this.isEditingContactInfo();
  }

  hasContactInfoConfirmPending(): boolean {
    return this._contactInfoConfirmPending();
  }

  clearAllState(): void {
    this._paymentFormDirty.set(false);
    this._contactInfoFormDirty.set(false);
    this._contactInfoConfirmPending.set(false);
    this._contactInfoEditingIndex.set(-1);
  }

  clearPaymentState(): void {
    this._paymentFormDirty.set(false);
  }

  clearContactInfoState(): void {
    this._contactInfoFormDirty.set(false);
    this._contactInfoEditingIndex.set(-1);
  }

  setHelocFormDirty(isDirty: boolean): void {
    this._helocFormDirty.set(isDirty);
  }

  hasHelocChanges(): boolean {
    return this._helocFormDirty();
  }

  clearHelocState(): void {
    this._helocFormDirty.set(false);
  }
}
